import { Classes, ProgressBar, ProgressBarProps } from "@blueprintjs/core";
import { rgba } from "polished";
import React from "react";
import styled from "styled-components";

const StyledProgressBar = styled(ProgressBar)<{
  $small?: boolean;
}>`
  ${({ $small }) =>
    $small &&
    `height: 4px;
  `}
  background: ${({ theme }) =>
    rgba(theme.button.subtleOrMinimal.none.backgroundColor, 0.3)};
  &.${Classes.INTENT_PRIMARY} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.PRIMARY};
    }
  }
  &.${Classes.INTENT_SUCCESS} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.SUCCESS};
    }
  }
  &.${Classes.INTENT_WARNING} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.WARNING};
    }
  }
  &.${Classes.INTENT_DANGER} {
    .${Classes.PROGRESS_METER} {
      background-color: ${({ theme }) => theme.intent.DANGER};
    }
  }
`;

export type HexProgressBarProps = Omit<ProgressBarProps, "animate|stripes"> & {
  $small?: boolean;
};

/**
 * https://blueprintjs.com/docs/#core/components/progress-bar
 */
export const HexProgressBar: React.ComponentType<HexProgressBarProps> =
  React.memo(function HexProgressBar({ $small, ...props }) {
    return (
      <StyledProgressBar
        $small={$small}
        animate={false}
        stripes={false}
        {...props}
      />
    );
  });
